export const AXIS = { X: 'X' };
export const ALIGNMENT = { MIDDLE: 'MIDDLE' };

export function scrollToElement(
  containerElement,
  targetElement,
  durationInMs,
  axis,
  alignment
) {
  let toPosition;
  if (alignment === ALIGNMENT.MIDDLE) {
    toPosition = getToMiddlePosition(targetElement);
  } else {
    throw new Error(`Alignment must be ${ALIGNMENT}.`);
  }
  scrollTo(containerElement, toPosition, durationInMs, axis);
}

function getToMiddlePosition(targetElement) {
  const targetElementRectangle = targetElement.getBoundingClientRect(); // target po
  const centerOfWindow = window.innerWidth / 2;
  const centerOfTargetElement =
    (targetElementRectangle.left + targetElementRectangle.right) / 2;

  // pixels needed to get target element to center of page
  return centerOfTargetElement - centerOfWindow;
}

function scrollTo(containerElement, toPosition, durationInMs, axis) {
  let startPosition;
  if (axis === AXIS.X) {
    startPosition = containerElement.scrollLeft;
  } else {
    throw new Error(`Axis must be ${AXIS.X}`);
  }
  const startTime = performance.now();
  let now;
  let elapsed;
  let t;

  function animateScroll() {
    now = performance.now();
    elapsed = now - startTime;
    t = elapsed / durationInMs;

    if (axis === AXIS.X) {
      containerElement.scrollLeft =
        startPosition + toPosition * easeInOutQuad(t);
    } else {
      throw new Error(`Axis must be ${AXIS.X}`);
    }

    if (t < 1) {
      window.requestAnimationFrame(animateScroll);
    }
  }

  animateScroll();
}

function easeInOutQuad(t) {
  return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
}
